import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-feedback-status-modal",
  templateUrl: "./feedback-status-modal.component.html",
  styleUrls: ["./feedback-status-modal.component.scss"],
})
export class FeedbackStatusModalComponent implements OnInit, OnDestroy {
  changeStatusForm!: FormGroup;
  ngUnSubscribe = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiservice: ApiService,
    private matDialogRef: MatDialogRef<FeedbackStatusModalComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.formInit(this.data);
    }
  }
  formInit(data: any) {
    this.changeStatusForm = new FormGroup({
      status: new FormControl(
        data?.reviewStatus === "New" ? "" : data?.reviewStatus || "",
        [Validators.required]
      ),
    });
  }

  changeStatus() {
    if (this.changeStatusForm.valid) {
      this.apiservice
        .patch(
          endpoints.reputation.feedback.feedbackStatus(this.data?.reviewId),
          {
            status: this.changeStatusForm.value?.status,
          }
        )
        .pipe(takeUntil(this.ngUnSubscribe))
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res?.body) {
              this.apiservice.alert(res.body?.message, ErrorType.Success);
              this.matDialogRef.close("ModalClosedByApi");
            }
          },
          (err: HttpErrorResponse) => {
            this.apiservice.alert(err.message, ErrorType.Error);
          }
        );
    } else {
      this.changeStatusForm.markAllAsTouched();
    }
  }
  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
